import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/home.module.css';

const FeatureSection = ({
  title,
  description,
  bulletPoint,
  buttonText,
  buttonLink,
  image,
  imageAlt,
  reverse = false,
  sectionClass = styles.feature
}) => {
  const contentClass = reverse ? styles.viewContent : styles.viewText;
  const textClass = reverse ? styles.newText : '';

  return (
    <section className={sectionClass}>
      {!reverse && (
        <p style={{
          color: "green",
          textAlign: "center",
          marginTop: "20px",
          fontSize: "1.7em",
        }}>
          FEATURES
        </p>
      )}
      {!reverse && (
        <h2 className={styles.featureTitle} style={{ textAlign: "center", fontSize: "1.4em" }}>
          A Single Platform For All Payment
        </h2>
      )}

      <div className={contentClass} style={{ flex: 1 }}>
        <div className={textClass}>
          <h3 style={{ fontSize: "1.5em" }} className={styles.head}>
            {title}
          </h3>
          <p style={{ fontSize: "1.1em" }} className={styles.paragraph}>
            {description}
          </p>
          <p>
            <span style={{ fontSize: "1.5em" }} className={styles.icon}>
              ✦
            </span>{" "}
            {bulletPoint}
          </p>
          <Link to={buttonLink}>
            <button className={`${styles.primaryButton} ${styles.webSignUpButton}`}>
              {buttonText}
            </button>
          </Link>
        </div>
        <div
          className={reverse ? styles.featuresImage : styles.imageSession}
          style={{
            position: "relative",
            display: "inline-block",
            gap: "50px",
          }}
        >
          <img
            src={image}
            alt={imageAlt}
            style={{
              maxWidth: "450px",
              height: "250px",
              display: "block",
              borderRadius: "8px",
            }}
          />
        </div>
      </div>
      <Link to={buttonLink}>
        <button className={`${styles.primaryButton} ${styles.mobileSignUp}`}>
          {buttonText}
        </button>
      </Link>
    </section>
  );
};

export default FeatureSection;